export default __webpack_public_path__ + "static/media/circleContact.38aa54f2.svg";